import useAppNavigate from "../../components/router/use-app-navigate";
import ProductList from "../../components/product/list";

export default function Purchase() {
  let navigate = useAppNavigate();
  return <ProductList onSuccess={(id) => navigate(`/payment/${id}`)} />;
}
